import VueI18n from 'vue-i18n'
import { RouteConfig } from 'vue-router'

const ConfigurationView: DynamicImport = () => import(/* webpackChunkName: "tickets" */ '../views/ConfigurationView.vue')
const TagsList: DynamicImport = () => import(/* webpackChunkName: "tickets" */ '../views/TagsListView.vue')
const TemplatesList: DynamicImport = () => import(/* webpackChunkName: "tickets" */ '../views/TemplatesListView.vue')
const CategoriesList: DynamicImport = () => import(/* webpackChunkName: "tickets" */ '../views/CategoriesListView.vue')

const configRoutes: (i18n: VueI18n) => RouteConfig[] = i18n => ([
  {
    name: 'tickets-configuration',
    path: 'tickets/configuration',
    component: ConfigurationView,
    meta: {
      title: i18n.t('tickets.configuration.pageTitle'),
      appModule: 'tickets',
      userPermission: ['tickets', 1]
    }
  },
  {
    name: 'tickets-tags',
    path: 'tickets/tags',
    component: TagsList,
    meta: {
      title: i18n.t('tickets.tags.pageTitle'),
      appModule: 'tickets',
      userPermission: ['tickets', 1]
    }
  },
  {
    name: 'tickets-templates',
    path: 'tickets/templates',
    component: TemplatesList,
    meta: {
      title: i18n.t('tickets.templates.pageTitle'),
      appModule: 'tickets',
      userPermission: ['tickets', 1]
    }
  },
  {
    name: 'tickets-categories',
    path: 'tickets/categories',
    component: CategoriesList,
    meta: {
      title: i18n.t('tickets.categories.pageTitle'),
      appModule: 'tickets',
      userPermission: ['tickets', 1]
    }
  }
])

export default configRoutes
